import * as type from '@/utvStore/store/mutation-types'
import { PAYMENT_API, SUBSC_API, CHOUN_API, ACADEMY_API, ULMAR_API } from '@/utvStore/store/API'
import store from '@/utvStore/store'
import { PAYEE } from '@/CONSTS'

const initialState = {
  card: {
    brandCode: '',
    expiration: '',
    expirationMonth: '',
    expirationYear: '',
    number: ''
  },
  payee: [],
  lastPayee: '',
  academy: {
    brandCode: '',
    expiration: '',
    expirationMonth: '',
    expirationYear: '',
    number: ''
  },
}


const state = Object.assign({}, initialState)

const actions = {
  /**
   * クレジットカード情報を取得する
   * @param {Object} data APIに渡すパラメータ。
   * { String } access_token
   */
  [type.GET_PAYMENT_INFO]({ commit }, data) {
    return axios.post(PAYMENT_API.getCredit, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject()
        } else if (res.data.response === 'OK') {
          const card = {
            number: res.data.cc_number,
            expiration: res.data.cc_expiration,
            brandCode: res.data.cardbrand_code,
            expirationYear: res.data.cc_expiration_y,
            expirationMonth: res.data.cc_expiration_m
          }
          commit(type.GET_PAYMENT_INFO, card)
        }
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * クレジットカード情報を更新する
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   access_token: String - アクセストークン
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
  [type.UPDATE_PAYMENT_INFO]({ commit }, data) {
    return axios.post('/mypage/change_credit_api', data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * vuex stateからクレカ情報を削除する
   */
  [type.RESET_PAYMENT_INFO]({ commit }) {
    commit(type.RESET_PAYMENT_INFO)
  },
  /**
   * クレジットカード情報を取得する
   * @param {Object} data - {access_token: 'xxxxxxxxxx'}形式のオブジェクト
   */
  [type.DELETE_PAYMENT_INFO]({ commit }, data) {
    return axios.post('/mypage/delete_credit_api', data).then(
      res => {
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.DELETE_PAYMENT_INFO)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * 支払い情報履歴を取得する
   * @param {Object} data - {access_token: 'xxxxxxxxxx'}形式のオブジェクト
   */
  [type.GET_PAYMENT_HISTORY]({ commit }, data) {
    return axios.post('/payment/get_settlements_api', data).then(
      res => {
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.GET_PAYMENT_HISTORY, res.data)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * サブスク登録　（クレジットカード情報登録）
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   access_token: String - アクセストークン
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
  [type.UPDATE_PAYMENT_INFO_SUBSC]({ commit }, data) {
    return axios.post(SUBSC_API.subscStart, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * サブスク再開　（クレジットカード情報登録）
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   access_token: String - アクセストークン
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
  [type.UPDATE_PAYMENT_INFO_SUBSC_REJOIN]({ commit }, data) {
    return axios.post(SUBSC_API.subscRejoin, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * 超運ダイアリー登録　（クレジットカード情報登録）
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   access_token: String - アクセストークン
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
  [type.UPDATE_PAYMENT_INFO_CHOUN]({ commit }, data) {
    return axios.post(CHOUN_API.subscStart, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * 超運ダイアリー　（クレジットカード情報登録）
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   access_token: String - アクセストークン
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
  [type.UPDATE_PAYMENT_INFO_CHOUN_REJOIN]({ commit }, data) {
    return axios.post(CHOUN_API.subscRejoin, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * 占いアカデミー　クレジットカード情報を取得する
   * @param {Object} data APIに渡すパラメータ。
   * { String } userId アカデミーのUID
   */
   [type.GET_PAYMENT_INFO_ACADEMY]({ commit }, data) {
    return axios.post(ACADEMY_API.getCredit, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject()
        } else if (res.data.response === 'OK') {
          const academy = {
            number: res.data.cc_number,
            expiration: res.data.cc_expiration,
            brandCode: res.data.cardbrand_code,
            expirationYear: res.data.cc_expiration_y,
            expirationMonth: res.data.cc_expiration_m
          }
          commit(type.GET_PAYMENT_INFO_ACADEMY, academy)
        }
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * 占いアカデミー　クレジットカード情報を更新する
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   userId: String - アカデミーのUID
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
   [type.UPDATE_PAYMENT_INFO_ACADEMY]({ commit }, data) {
    return axios.post(ACADEMY_API.updateCredit, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO_ACADEMY)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * ユルマール　クレジットカード情報を取得する
   * @param {Object} data APIに渡すパラメータ。
   * { String } userId ユルマールのUID
   */
  [type.GET_PAYMENT_INFO_ULMAR]({ commit }, data) {
    return axios.post(ULMAR_API.getCredit, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject()
        } else if (res.data.response === 'OK') {
          const academy = {
            number: res.data.cc_number,
            expiration: res.data.cc_expiration,
            brandCode: res.data.cardbrand_code,
            expirationYear: res.data.cc_expiration_y,
            expirationMonth: res.data.cc_expiration_m
          }
          commit(type.GET_PAYMENT_INFO_ACADEMY, academy)
        }
      },
      error => {
        throw new Error(error)
      }
    )
  },
  /**
   * ユルマール　クレジットカード情報を更新する
   * @param {Object} data APIに渡すパラメータ。
   * {
   *   userId: String - ユルマールのUID
   *   token: String - クレカ情報トークン
   *   tokenKey: String - クレカ情報tokenkey
   * }
   */
  [type.UPDATE_PAYMENT_INFO_ULMAR]({ commit }, data) {
    return axios.post(ULMAR_API.updateCredit, data).then(
      res => {
        // NGが返った場合reject
        if (res.data.response === 'NG') {
          return Promise.reject(res.data)
        }
        commit(type.UPDATE_PAYMENT_INFO_ULMAR)
      },
      error => {
        throw new Error(error)
      }
    )
  },
}


/**
 * カードを画面表示用にフォーマットする
 * @param {String} brand - sbps apiから取得したカードブランドコード
 * @param {String} number - sbps apiから取得したカード番号
 */
function _getDisplayCardStr(brand, number) {
  if (!brand || !number) {
    return ''
  }
  const displayNumber = number.replace(/[^0-9]/g, '')
  return `${brand}-${displayNumber}`
}

/**
 * カードを画面表示用にスペース区切りでフォーマットする
 * @param {String} number - sbps apiから取得したカード番号
 */
function _getDisplayCardStrWithSpace(number) {
  return String(number).replace(/([\u\l\d.*])(?=([\u\l\d.*]{4})+(?![\u\l\d.*]))/g, '$1 ')
}

const getters = {
  hasCardPaymentLog: _state => {
    return _state.card ? Boolean(_state.card.number) : false
  },
  cardNumberStr: _state => {
    return _getDisplayCardStrWithSpace(_state.card.number)
  },
  /**
   * 最後に利用した決済情報から支払い方法の文字列を作成する
   * @return { String } - 「ドコモ払い」など決済種別の文字列(※ どれにも該当しない場合空の文字列となる)
   **/
  paymentTypeStr: _state => {
    switch (_state.lastPayee) {
      case PAYEE.CREDIT_CODE: {
        return `${PAYEE.CREDIT_LABEL} ${_getDisplayCardStrWithSpace(_state.card.number)}`
        break
      }
      case PAYEE.DOCOMO_CODE: {
        return PAYEE.DOCOMO_LABEL
        break
      }
      case PAYEE.KDDI_CODE: {
        return PAYEE.KDDI_LABEL
        break
      }
      case PAYEE.SOFTBANK_LABEL: {
        return PAYEE.SOFTBANK_LABEL
        break
      }
      default: {
        return ''
      }
    }
  }
}

const mutations = {
  [type.GET_PAYMENT_INFO](_state, card) {
    Object.assign(_state, { card })
  },
  [type.UPDATE_PAYMENT_INFO](_state) {},
  [type.RESET_PAYMENT_INFO](_state) {
    Object.assign(_state, initialState)
  },
  [type.DELETE_PAYMENT_INFO](_state) {
    Object.assign(_state, initialState)
  },
  [type.GET_PAYMENT_HISTORY](_state, data) {
    Object.assign(_state, {
      payee: data.payee,
      lastPayee: data.payee[0] || ''
    })
  },
  [type.GET_PAYMENT_INFO_ACADEMY](_state, academy) {
    Object.assign(_state, { academy })
  },
  [type.UPDATE_PAYMENT_INFO_ACADEMY](_state) {},
  [type.GET_PAYMENT_INFO_ULMAR](_state, ulmar) {
    Object.assign(_state, { ulmar })
  },
  [type.UPDATE_PAYMENT_INFO_ULMAR](_state) {},
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/payment.js